import React from 'react';
import './Services.css';

const SERVICES = [
  {
    num: '/01',
    title: 'AI Products & Calling Agents',
    desc: 'Our speciality. Custom AI products and voice calling agents built for your industry: agents that answer, qualify, book, and follow up around the clock, wired into your CRM and tools.',
    tags: ['Custom AI products', 'Voice calling agents', 'Healthcare', 'Real estate', 'Finance', 'Retail & e-commerce'],
    featured: true,
  },
  { num: '/02', title: 'Software Development', desc: 'Web and mobile products built end to end by senior engineers.' },
  { num: '/03', title: 'CRM Services', desc: 'Setup, migration, automation, and reporting: a CRM your team actually uses.' },
  { num: '/04', title: 'Digital Marketing', desc: 'Campaigns, content, SEO, and paid, connected straight to your pipeline.' },
  { num: '/05', title: 'Design & Support', desc: 'UI/UX design plus ongoing maintenance and iteration after launch.' },
];

export default function Services() {
  return (
    <section className="services" id="services">
      <div className="services-heading">
        <h2 data-reveal>What we do</h2>
        <div className="services-eyebrow" data-reveal>SERVICES</div>
      </div>
      <div className="services-grid">
        {SERVICES.map((svc) => (
          <div
            className={`service-card${svc.featured ? ' service-card-featured' : ''}`}
            data-reveal
            data-tilt={svc.featured ? undefined : true}
            key={svc.num}
          >
            <div className="service-num">
              {svc.num}
              {svc.featured && <span className="service-badge">Speciality</span>}
            </div>
            <div className="service-title">{svc.title}</div>
            <div className="service-desc">{svc.desc}</div>
            {svc.tags && (
              <ul className="service-tags">
                {svc.tags.map((tag) => (
                  <li key={tag}>{tag}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
